/** @format — Aligns with sidebar logo row (52px) */

import React from "react";

/**
 * @param {{ children: React.ReactNode; className?: string; actions?: React.ReactNode }} props
 */
export default function PageTitle({ children, className = "", actions = null }) {
  return (
    <div
      className={`box-border flex h-[52px] shrink-0 items-center justify-between px-5 ${className}`}
    >
      <h1 className="m-0 text-[20px] font-semibold leading-none text-[#11121A]">{children}</h1>
      {actions}
    </div>
  );
}
